import{__moduleExports as o}from"../node_modules/store/src/util.js";export default o;
